
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"34","stroke":"#303D4E","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.092 2.833v4.25M23.425 2.833v4.25M5.717 12.877H29.8M5.009 18.43v-6.388c0-4.25 2.125-7.084 7.083-7.084h11.333c4.959 0 7.084 2.834 7.084 7.084v12.041c0 4.25-2.125 7.084-7.084 7.084H12.092c-4.958 0-7.083-2.834-7.083-7.084","stroke":"inherit","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.993 19.408h.013M22.993 23.658h.013M17.752 19.408h.013M17.752 23.658h.013M12.51 19.408h.012M12.51 23.658h.012","stroke":"inherit","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    